import React from 'react';
import {
  View,
  Text,
  StyleSheet,
  SafeAreaView,
  TouchableOpacity,
  Image,
  ScrollView,
} from 'react-native';
import { ms, s, vs } from '../../../../utils/responsive';
import { useNavigation } from '@react-navigation/native';
import { RootStackNavigationProp } from '../../../../types/navigation';
import { BottomNavBar } from '../../../../components/BottomNavBar';
import { tasksService } from '../../../../services/tasks';
import { mapTaskIdToKey } from '../../../../utils/taskKey';

import { createLogger } from '../../../../utils/logger';
const logger = createLogger('MusicIntro');

export const MusicIntroScreen: React.FC = () => {
  const navigation = useNavigation<RootStackNavigationProp>();

  const handleYes = () => {
    navigation.navigate('MusicInput');
  };

  const handleNo = async () => {
    try {
      const taskKey = mapTaskIdToKey(74); // Music task ID
      await tasksService.completeTask(taskKey);
      // Mark decline flag so safeguards keep it completed without data
      const AsyncStorage = require('@react-native-async-storage/async-storage').default;
      await AsyncStorage.setItem('task_declined_74', 'true');
    } catch (e) {
      // Non-blocking; still return to checklist
      logger.debug('Error completing music task on decline:', e);
    }
    // Navigate explicitly to the Wishes stack's checklist to trigger focus/refresh
    (navigation as any).navigate('Wishes', { screen: 'FinalWishesChecklist', params: { refreshKey: Date.now() } });
  };


  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.mainContent}>
        <View style={styles.header}>
          <TouchableOpacity
            style={styles.backButton}
            onPress={() => navigation.goBack()}
          >
            <Image
              source={require('../../../../assets/icons/back.png')}
              style={styles.backIcon}
            />
          </TouchableOpacity>
          <Image
            source={require('../../../../assets/logo.png')}
            style={styles.logo}
            resizeMode="contain"
          />
        </View>

        <ScrollView contentContainerStyle={styles.content}>
          <Text style={styles.title}>Is there any specific music, songs, or a playlist you would like to be played during your memorial service?</Text>

          <View style={styles.buttonContainer}>
            <TouchableOpacity
              style={[styles.button, styles.yesButton]}
              onPress={handleYes}
            >
              <Text style={[styles.buttonText, styles.yesText]}>Yes</Text>
            </TouchableOpacity>

            <TouchableOpacity
              style={[styles.button, styles.noButton]}
              onPress={handleNo}
            >
              <Text style={[styles.buttonText, styles.noText]}>No</Text>
            </TouchableOpacity>
          </View>

          <Text style={styles.description}>
            Choosing songs or a playlist for your service helps set the tone and reflect your personality, values, and memories. Whether it's spiritual hymns, favorite artists, or meaningful lyrics, music can help celebrate your life in a deeply personal way.
          </Text>
        </ScrollView>
      </View>
      <BottomNavBar />
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#FFFFFF',
  },
  mainContent: {
    flex: 1,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    padding: ms(15),
    paddingTop: ms(50),
    position: 'relative',
  },
  backButton: {
    position: 'absolute',
    left: ms(50),
    top: ms(15),
    padding: ms(5),
    zIndex: 1,
  },
  backIcon: {
    width: ms(32, 0.3),
    height: ms(32, 0.3),
    tintColor: '#333',
  },
  logo: {
    width: ms(125, 0.3),
    height: ms(125, 0.3),
  },
  content: {
    flexGrow: 1,
    padding: ms(20),
    alignItems: 'center',
  },
  title: {
    fontSize: ms(26, 0.3),
    fontWeight: '600',
    color: '#2C4364',
    marginBottom: ms(30),
    textAlign: 'center',
    paddingHorizontal: ms(20),
  },
  description: {
    fontSize: ms(18, 0.3),
    color: '#666666',
    textAlign: 'center',
    marginTop: ms(30),
    paddingHorizontal: ms(20),
    lineHeight: ms(25, 0.3),
  },
  buttonContainer: {
    width: '100%',
    paddingHorizontal: ms(20),
  },
  button: {
    width: '100%',
    borderRadius: ms(30),
    padding: ms(15),
    alignItems: 'center',
    marginBottom: ms(15),
  },
  yesButton: {
    backgroundColor: '#29BFC0',
  },
  noButton: {
    backgroundColor: '#FF9F64',
  },
  buttonText: {
    fontSize: ms(16, 0.3),
    fontWeight: '500',
  },
  yesText: {
    color: '#FFFFFF',
  },
  noText: {
    color: '#FFFFFF',
  },
});

export default MusicIntroScreen;
